module.exports = __webpack_public_path__ + "static/media/ibd_arm3.d6e8721c.png";